import { createStore }  from 'vuex';
import globals from './modules/globals';

export const store = createStore({
    modules: {
        globals,
    }
});
